import { useState, useEffect, useCallback } from "react"
import QuoteDate from "components/quoteComponents/QuoteDate";
import api from "api";
const QuoteNew = (
    {
        setNewQuote, // flag pour fermer le mode création
        setReloadQuotes, // flag pour recharger la liste des devis
        setEditQuote, // flag pour ouvrir le mode modification
        setSelectedQuote, // devis à modifier
    }
) => {

    const [ selectedDates, setSelectedDates ] = useState([]); // liste pour recevoir la première date d'utilisation

    // gère l'enregistrement d'une première date ce qui déclenche l'ouverture d'un nouveau devis
    const onChange = (dates)=>{
        api.post(`quote/add`, {
            delivery : false,
            event : "",
            name : "",
            phone : "",
            priced : false,
        })
        .then(response => {
            const quote_id = response.data.id
            const timestamps = dates[0].getTime()
            api.put(`quote/${quote_id}/setdates`, { new_dates : [timestamps] })
            .then( () => {
                response.data.first_date = dates[0];
                response.data.last_date = dates[0];
                setReloadQuotes(true);
                setSelectedQuote(response.data);
                setEditQuote(true);
                setNewQuote(false);
            });
        })
    };

    // fonction pour quitter le mode création
    const handleClick = useCallback(() => {
        setNewQuote(false)
    }, [setNewQuote]);
    
    // fonction pour traiter la touche ECHAP
    const handleKey = useCallback((e) => {
        if (e.key === 'Escape') handleClick();
    }, [handleClick]);

    // fonction pour intercepter le clavier
    useEffect(() => {
        document.addEventListener('keydown',handleKey);
        return () => { 
            document.removeEventListener('keydown',handleKey);
        }
    },[handleKey])

    return (
        <>
            <div
                className="RentmanClose"
                onClick={handleClick}
            >
                X
            </div>
            <div className="RentmanQuoteEdit">
                <QuoteDate
                    selectedDates = {selectedDates}
                    setSelectedDates = {setSelectedDates}
                    onChange={onChange}
                />   
            </div>
        </>
    )
}

export default QuoteNew;